var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-input-money" }, [
    _c("input", {
      directives: [
        {
          name: "currency",
          rawName: "v-currency",
          value: {
            currency: null,
            locale: "ja",
            precision: 0,
            distractionFree: false,
            allowNegative: _vm.allowNegative
          },
          expression:
            "{currency: null, locale: 'ja', precision: 0, distractionFree: false, allowNegative: allowNegative}"
        },
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayValue,
          expression: "displayValue"
        },
        {
          name: "validate",
          rawName: "v-validate",
          value: _vm.validation,
          expression: "validation"
        }
      ],
      ref: "input",
      staticClass: "form-control text-right",
      attrs: { type: "text", name: "money", "data-vv-as": _vm.label },
      domProps: { value: _vm.displayValue },
      on: {
        blur: _vm.handleBlur,
        focus: _vm.handleFocus,
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.displayValue = $event.target.value
          },
          _vm.handleInput
        ]
      }
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("money") && _vm.inputDirty,
            expression: "errors.has('money') && inputDirty"
          }
        ],
        staticClass: "text-danger"
      },
      [_vm._v("※" + _vm._s(_vm.errors.first("money")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0244c646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0244c646","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputMoney.vue
// module id = null
// module chunks = 